var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("section", { staticClass: "optimization-example" }, [
    _c(
      "button",
      {
        staticClass: "back-link",
        attrs: { type: "button" },
        on: { click: _vm.goBack },
      },
      [
        _c("a-icon", { attrs: { type: "left" } }),
        _vm._v(" " + _vm._s(_vm.$t("ExBack")) + " "),
      ],
      1
    ),
    _c("section", { staticClass: "overview-card" }, [
      _c("h1", [
        _c("span", { staticClass: "play-mark" }, [_vm._v("▶")]),
        _vm._v(" " + _vm._s(_vm.$t("ExOverviewTitle")) + " "),
      ]),
      _c("p", {
        staticClass: "sub-copy",
        domProps: { innerHTML: _vm._s(_vm.$t("ExSubCopy")) },
      }),
      _c(
        "div",
        { staticClass: "pain-grid" },
        [
          _c("div", { staticClass: "pain-column" }, [
            _c("h2", [_vm._v(_vm._s(_vm.$t("ExPainManualTitle")))]),
          ]),
          _c("div", {
            staticClass: "pain-head-spacer",
            attrs: { "aria-hidden": "true" },
          }),
          _c("div", { staticClass: "pain-column pain-column-sb" }, [
            _c("h2", [_vm._v(_vm._s(_vm.$t("ExPainSBTitle")))]),
          ]),
          _vm._l(_vm.painRows, function (row, index) {
            return [
              _c("div", { key: "manual-" + index, staticClass: "manual-row" }, [
                _c("span", [_vm._v(_vm._s(row.problem.icon))]),
                _c("p", [_vm._v(_vm._s(row.problem.text))]),
              ]),
              _c("span", { key: "arrow-" + index, staticClass: "pain-arrow" }, [
                _vm._v("→"),
              ]),
              _c("div", { key: "auto-" + index, staticClass: "auto-row" }, [
                _c("span", [_vm._v(_vm._s(row.benefit.icon))]),
                _c("p", { domProps: { innerHTML: _vm._s(row.benefit.text) } }),
              ]),
            ]
          }),
        ],
        2
      ),
      _c(
        "div",
        { staticClass: "industry-row" },
        [
          _c("strong", [_vm._v(_vm._s(_vm.$t("ExAnyIndustry")))]),
          _vm._l(_vm.industries, function (industry) {
            return _c("span", { key: industry }, [
              _vm._v(" " + _vm._s(industry) + " "),
            ])
          }),
          _c("em", [_vm._v(_vm._s(_vm.$t("ExAnyIndustryNote")))]),
        ],
        2
      ),
    ]),
    _c("section", { staticClass: "step-card" }, [
      _c("header", { staticClass: "step-title" }, [
        _c("span", [_vm._v("1")]),
        _c("h2", { domProps: { innerHTML: _vm._s(_vm.$t("ExStep1Title")) } }),
      ]),
      _c("div", { staticClass: "target-flow" }, [
        _c("article", { staticClass: "flow-box account" }, [
          _c("div", { staticClass: "flow-icon" }, [_vm._v("🔗")]),
          _c("h3", [_vm._v(_vm._s(_vm.$t("ExFlowAccountTitle")))]),
          _c("strong", [_vm._v(_vm._s(_vm.$t("ExFlowAccountStrong")))]),
          _c("p", [_vm._v(_vm._s(_vm.$t("ExFlowAccountP")))]),
        ]),
        _c("span", { staticClass: "flow-arrow" }, [_vm._v("→")]),
        _c("article", { staticClass: "flow-box source" }, [
          _c("div", { staticClass: "flow-icon" }, [_vm._v("⚙️")]),
          _c("h3", [_vm._v(_vm._s(_vm.$t("ExFlowSourceTitle")))]),
          _c("strong", [_vm._v(_vm._s(_vm.$t("ExFlowSourceStrong")))]),
          _c("p", [_vm._v(_vm._s(_vm.$t("ExFlowSourceP")))]),
        ]),
        _c("span", { staticClass: "flow-arrow" }, [_vm._v("→")]),
        _c("article", { staticClass: "flow-box customers" }, [
          _c("div", { staticClass: "flow-icon" }, [_vm._v("👥")]),
          _c("h3", [_vm._v(_vm._s(_vm.$t("ExFlowCustomersTitle")))]),
          _c("p", {
            domProps: { innerHTML: _vm._s(_vm.$t("ExFlowCustomersP")) },
          }),
        ]),
      ]),
      _c(
        "div",
        { staticClass: "avatar-cluster" },
        [
          _vm._l(_vm.avatars, function (avatar) {
            return _c("span", { key: avatar }, [_vm._v(_vm._s(avatar))])
          }),
          _c("b", [_vm._v("+235")]),
        ],
        2
      ),
      _c("p", { staticClass: "hint" }, [_vm._v(_vm._s(_vm.$t("ExHint")))]),
    ]),
    _c("section", { staticClass: "step-card chat-step" }, [
      _c("header", { staticClass: "step-title" }, [
        _c("span", [_vm._v("2")]),
        _c("h2", { domProps: { innerHTML: _vm._s(_vm.$t("ExStep2Title")) } }),
      ]),
      _c(
        "div",
        { staticClass: "feature-bar" },
        _vm._l(_vm.chatFeatures, function (feature) {
          return _c("span", { key: feature }, [_vm._v("✅ " + _vm._s(feature))])
        }),
        0
      ),
      _c("p", {
        staticClass: "chat-copy",
        domProps: { innerHTML: _vm._s(_vm.$t("ExChatCopy")) },
      }),
      _c(
        "div",
        { staticClass: "chat-grid" },
        _vm._l(_vm.conversations, function (conversation) {
          return _c(
            "article",
            { key: conversation.name, staticClass: "conversation-card" },
            [
              _c("div", { staticClass: "conversation-head" }, [
                _c("div", { staticClass: "person" }, [
                  _c("span", [_vm._v(_vm._s(conversation.initial))]),
                  _c("div", [
                    _c("h3", [_vm._v(_vm._s(conversation.name))]),
                    _c("p", [_vm._v(_vm._s(conversation.role))]),
                  ]),
                ]),
                _c("strong", [
                  _c("span", { staticClass: "linkedin-mark" }, [_vm._v("in")]),
                  _vm._v(" " + _vm._s(_vm.$t("ExInYourLinkedIn")) + " "),
                ]),
              ]),
              _c("div", { staticClass: "conversation-body" }, [
                _c(
                  "div",
                  { staticClass: "conversation-scroll" },
                  [
                    _c("p", { staticClass: "account-note" }, [
                      _vm._v(_vm._s(_vm.$t("ExAccountNote"))),
                    ]),
                    _vm._l(conversation.messages, function (message) {
                      return _c(
                        "div",
                        { key: message.text, class: ["message", message.from] },
                        [
                          message.label
                            ? _c("small", [_vm._v(_vm._s(message.label))])
                            : _vm._e(),
                          _c("p", {
                            domProps: { innerHTML: _vm._s(message.text) },
                          }),
                        ]
                      )
                    }),
                  ],
                  2
                ),
                _c(
                  "button",
                  {
                    attrs: { type: "button" },
                    on: {
                      click: function ($event) {
                        return _vm.openConversation(conversation)
                      },
                    },
                  },
                  [_vm._v(" " + _vm._s(_vm.$t("ExClickEnlarge")) + " ")]
                ),
              ]),
              _c("footer", [_vm._v("✅ " + _vm._s(conversation.footer))]),
            ]
          )
        }),
        0
      ),
      _c("p", { staticClass: "footnote" }, [
        _vm._v(_vm._s(_vm.$t("ExFootnote"))),
      ]),
    ]),
    _c("section", { staticClass: "step-card result-step" }, [
      _c("header", { staticClass: "step-title" }, [
        _c("span", [_vm._v("3")]),
        _c("h2", [_vm._v(_vm._s(_vm.$t("ExStep3Title")))]),
      ]),
      _c("p", {
        staticClass: "result-copy",
        domProps: { innerHTML: _vm._s(_vm.$t("ExResultCopy")) },
      }),
      _c("div", { staticClass: "metric-grid" }, [
        _c("article", [
          _c("span", [_vm._v("🤝")]),
          _c("strong", [_vm._v("8")]),
          _c("p", [_vm._v(_vm._s(_vm.$t("ExMetricInterested")))]),
        ]),
        _c("article", [
          _c("span", [_vm._v("📞")]),
          _c("strong", { staticClass: "orange" }, [_vm._v("5")]),
          _c("p", [_vm._v(_vm._s(_vm.$t("ExMetricContact")))]),
        ]),
      ]),
      _c(
        "div",
        { staticClass: "lead-list" },
        _vm._l(_vm.leads, function (lead) {
          return _c("div", { key: lead.name, staticClass: "lead-row" }, [
            _c("div", { staticClass: "lead-person" }, [
              _c("span", [_vm._v(_vm._s(lead.initial))]),
              _c("div", [
                _c("h3", [_vm._v(_vm._s(lead.name))]),
                _c("p", [_vm._v(_vm._s(lead.role))]),
              ]),
            ]),
            _c(
              "div",
              { staticClass: "lead-tags" },
              _vm._l(lead.tags, function (tag) {
                return _c("em", { key: tag, class: _vm.tagClass(tag) }, [
                  _vm._v(" " + _vm._s(_vm.$t(tag)) + " "),
                ])
              }),
              0
            ),
          ])
        }),
        0
      ),
      _c("p", { staticClass: "result-note" }, [
        _vm._v(_vm._s(_vm.$t("ExResultNote"))),
      ]),
    ]),
    _c(
      "section",
      { staticClass: "cta-card" },
      [
        _c("p", [_vm._v(_vm._s(_vm.$t("ExCtaCopy")))]),
        _c(
          "a-button",
          {
            staticClass: "cta-button",
            on: { click: _vm.handleCreateCampaign },
          },
          [
            _vm._v(" " + _vm._s(_vm.$t("ExCtaButton")) + " "),
            _c("a-icon", { attrs: { type: "arrow-right" } }),
          ],
          1
        ),
      ],
      1
    ),
    _vm.activeConversation
      ? _c(
          "div",
          {
            staticClass: "conversation-modal-mask",
            attrs: { role: "dialog", "aria-modal": "true" },
          },
          [
            _c("section", { staticClass: "conversation-modal" }, [
              _c("div", { staticClass: "conversation-head modal-head" }, [
                _c("div", { staticClass: "person" }, [
                  _c("span", [_vm._v(_vm._s(_vm.activeConversation.initial))]),
                  _c("div", [
                    _c("h3", [_vm._v(_vm._s(_vm.activeConversation.name))]),
                    _c("p", [_vm._v(_vm._s(_vm.activeConversation.role))]),
                  ]),
                ]),
                _c("strong", [
                  _c("span", { staticClass: "linkedin-mark" }, [_vm._v("in")]),
                  _vm._v(" " + _vm._s(_vm.$t("ExInYourLinkedIn")) + " "),
                ]),
                _c(
                  "button",
                  {
                    staticClass: "modal-close",
                    attrs: {
                      type: "button",
                      "aria-label": _vm.$t("ExModalClose"),
                    },
                    on: { click: _vm.closeConversation },
                  },
                  [_c("a-icon", { attrs: { type: "close" } })],
                  1
                ),
              ]),
              _c(
                "div",
                { staticClass: "conversation-body modal-body" },
                [
                  _c("p", { staticClass: "account-note" }, [
                    _vm._v(_vm._s(_vm.$t("ExAccountNote"))),
                  ]),
                  _vm._l(_vm.activeConversation.messages, function (message) {
                    return _c(
                      "div",
                      { key: message.text, class: ["message", message.from] },
                      [
                        message.label
                          ? _c("small", [_vm._v(_vm._s(message.label))])
                          : _vm._e(),
                        _c("p", [_vm._v(_vm._s(message.text))]),
                      ]
                    )
                  }),
                ],
                2
              ),
              _c("footer", [
                _vm._v("✅ " + _vm._s(_vm.activeConversation.footer)),
              ]),
            ]),
          ]
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }